import Api from "../utils/Api";

export const getRules = (token) => {
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return Api.get("rule", config);
};

export const getOneRule = (id, token) => {
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return Api.get("rule/" + id, config);
};

export const createRule = (data, token) => {
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return Api.post("admin/createRule", data, config);
};

export const updateRule = (data, token) => {
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return Api.patch("admin/updateRule", data, config);
};

export const saveGame = (data, token) => {
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return Api.post("match/create", data, config);
};
export const endScheduleGame = (id, data, token) => {
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return Api.patch(`match/${id}`, data, config);
};

export const suspendGame = (data, token) => {
  console.log("SUSPEND API !!! XXX", data);
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return Api.post("match/suspend", data, config);
};

// export const completeASuspendedGame = (data, token) => {
//   console.log("COMPLETED Suspended Game API !!! XXX", data);
//   const config = { headers: { Authorization: `Bearer ${token}` } };
//   return Api.patch("match/complete-suspended-match", data, config);
// };

export const getScheduledGames = (teamId, token) => {
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return Api.get(`match/scheduled-games/${teamId}`, config);
};

export const getOneScheduledGame = (id, token) => {
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return Api.get("match/" + id, config);
};

export const deleteSchedule = (id, token) => {
  const config = { headers: { Authorization: `Bearer ${token}` } };
  // return Api.patch("schedule-game/update-status/" + id, data, config);
  return Api.patch("match/" + id, { deletedAt: new Date() }, config);
};

export const createScheduledGame = (data, token) => {
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return Api.post("match/create", data, config);
};

export const editScheduledGame = (id, data, token) => {
  const config = { headers: { Authorization: `Bearer ${token}` } };
  return Api.patch("match/" + id, data, config);
};
